import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ActionText from '../../core/ActionText';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../../core/style/gstheme';
import ResourceDisplay from './ResourceDisplay';

class SearchResults extends Component {

  render() {

    const { classes, graph, resources, defaultLang, viewLang, project, ontologies } = this.props;

    if (!resources) return <ActionText offset="50px" format="result">No results.</ActionText>;

    return (
      <div data-test="search-results">
        <Table stickyHeader data-test="search-results-viewer" style={{ maxWidth: '100%', marginTop: 12 }}>
          <TableHead>
            <TableRow>
              {
                ["Label", "Type", "IRI", "(View) In Ontology"].map((col, index) =>
                  <TableCell key={index} component="th" className={classes.tableHeadingPlain}>{col}</TableCell>
                )
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {resources.map(resource => <ResourceDisplay
              suppressLoading={true}
              key={resource}
              components={ontologies}
              project={project}
              viewLang={viewLang}
              defaultLang={defaultLang}
              id={resource}
              graph={graph} />)}
          </TableBody>
        </Table>
      </div>
    );
  }

}

SearchResults.propTypes = {
  classes: PropTypes.object,
  resources: PropTypes.array,
  project: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string.isRequired,
  ontologies: PropTypes.array.isRequired,
  graph: PropTypes.string.isRequired
};

export default withStyles(styles)(SearchResults);